<template lang="pug">
.analysisDeviceDetail(v-loading="isLoading")
  template#device(v-if="device")
    header
      el-select.action(v-model="params.actions" :placeholder="$t('Analysis.Event.select_action')" size="small" multiple)
        el-option(v-for="action in actions" :key="action.type" :label="$t(action.name)" :value="action.type")
      el-select.group(v-model="params.groups" :placeholder="$t('Analysis.Event.select_group')" size="small" multiple)
        el-option(v-for="group in groups" :key="group.id" :label="group.name" :value="group.id")
      el-date-picker.picker(v-model="params.daterange" type="daterange" size="small" align="right" unlink-panels
                            range-separator="〜" :start-placeholder="$t('Analysis.start_date')"
                            :end-placeholder="$t('Analysis.end_date')" :picker-options="options"
                            :value-format="'yyyy-MM-dd'")

    #cuona
      .deviceImage
        img(:src="getCuonaImage(device.device_type)")
        span.name {{ device.name }}

      .dailyGraph
        template(v-if="chosenDay")
          h1
            a(@click="changeDaily") {{ $t('Analysis.Event.daily_touch_count') }}
            i.el-icon-arrow-right
            span.arrow {{ chosenDay }}
          HoursGraph(v-if="!dailyMode", :chosenDay="chosenDay" :actions="params.actions" :groups="params.groups")
        template(v-else)
          h1.none {{ $t('Analysis.Event.daily_touch_count') }}
          DailyGraph(v-if="dailyMode" @changeGraph="change24Hours" :actions="params.actions" :groups="params.groups"
            :daterange="params.daterange")

      .weatherGraph
        h1 {{ $t('Analysis.Device.title03') }}
        WeatherGraph(:envData="envData")

      #eventList
        h1 {{ $t('Analysis.User.title02') }}
        EventList(:device_name="device.name")

  template#none_device(v-else)
    p {{ $t('Analysis.Device.title04') }}

</template>

<script>
import actions from '@/utils/defines/actions.js'
import DailyGraph from './Daily'
import HoursGraph from './24Hours'
import WeatherGraph from './Weather'
import EventList from './EventList'
import DeviceApi from '@/api/cuona'
import AnalyticsApi from '@/api/analytics'
import GroupApi from '@/api/group'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      device: { },
      groups: [],
      eventCountsByActionTypeByDay: { },
      envData: { },
      dailyMode: true,
      chosenDay: null,
      isLoading: false,
      params: {
        actions: [],
        groups: [],
        daterange: []
      },
      options: {
        shortcuts: [{
          text: this.$t('Analysis.last_week'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('Analysis.last_month'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('Analysis.past_3month'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      images:{
        cube: require('@/assets/cuona_cube.png'),
        tag: require('@/assets/cuona_tag.svg'),
        unknown: require('@/assets/unknown.svg')
      }
    }
  },
  title () {
    return this.device.name
  },
  computed: {
    ...mapState({
      analysisFilters: state => state.analysis.analysisFilters
    })
  },
  watch : {
    device() {
      if (this.device) {
        this.setLastBreadcrumb()
      }
    },
    'params.actions'() {
      this.updateData();
    },
    'params.groups'() {
      this.updateData();
    },
    'params.daterange'() {
      this.updateData();
    }
  },
  components: { DailyGraph, HoursGraph, WeatherGraph, EventList },
  mixins: [actions],
  methods: {
    getGroups: function() {
      this.isLoading = true;
      GroupApi.getGroups()
        .then((groups) => {
          this.groups = groups;
        })
        .catch((error) => {
          this.$router.replace('/analysis/device');
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Group.failed_get'),
            type: 'error'
          });
        })
        .finally(() => this.isLoading = false);
    },
    isEmptyImg: function(url){
      return url != null ? url : require("@/assets/default.svg");
    },
    setLastBreadcrumb: function() {
      this.$store.commit('setLastBreadcrumb', this.device.name)
    },
    // CUONAのアイコンを設定
    getCuonaImage: function(type) {
      switch(type){
        case 'cube': return this.images.cube;
        case 'tag': return this.images.tag;
        default: return this.images.unknown;
      }
    },
    //グラフをタップすると時間表示へ切り替え
    change24Hours: function (date) {
      this.chosenDay = date
      this.dailyMode = false
    },
    changeDaily: function() {
      this.chosenDay = null
      this.dailyMode = true
    },
    updateData() {
      const obj = this;
      const reqParams = {
        nfc_uid: this.$route.params.nfc_uid,
        daterange: this.params.daterange,
        action_types: this.params.actions,
        groups: this.params.groups
      };
      DeviceApi.getDevice(this.$route.params.nfc_uid).then(function(response) {
        if (response) {
          obj.device = response;
        } else {
          obj.device = { };
        }
      });
      AnalyticsApi.getEnvData(reqParams).then(function(response) {
        if (response && response.env_data) {
          obj.envData = response.env_data;
        } else {
          obj.envData = { };
        }
      })
    }
  },
  mounted() {
    this.params = this.analysisFilters;
    this.updateData();
    this.getGroups();
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";

.analysisDeviceDetail {
  padding-top: 80px;

  header {
    position: fixed;
    z-index: 100;
    width: calc(100vw - 320px);
    margin-top: -80px;
    background: #FEFEFE;
    padding: 15px 40px;
    border-bottom: 1px solid $border;

    .action, .group {
      width: 240px;
      margin: 0 20px 0 0;
    }
    .picker {
      width: 280px;
      float: right;
    }
  }

  #cuona {
    background: #FFF;
    border: 1px solid $border;
    border-radius: 5px;
    margin: 60px 40px 30px 40px;

    .deviceImage {
      text-align: center;
      margin-top: -60px;
      img {
        width: 180px;
      }
      span.name {
        display: block;
      }
    }

    .dailyGraph, .weatherGraph {
      margin: 0 20px;

      h1 {
        font-size: 16px;
        font-weight: normal;
        margin-left: 20px;

        &.none {
          padding-left: 5px;
        }

        a {
          cursor: pointer;
          color: $safe;
          padding: 3px 5px;
          border-radius: 4px;

          &:hover {
            background: $border;
          }
        }
        span.arrow {
          margin-left: 3px;
        }
      }
    }

    .weatherGraph {
      margin: 50px 20px 40px 20px;
    }
  }

  #graphs, #eventList {
    padding: 10px 40px 30px 40px;

    h1 {
      font-size: 16px;
      font-weight: normal;
      margin-bottom: 10px;
    }

    .events {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }
  }

  #eventList {
    border-top: 1px solid $border;
  }

}

</style>
